var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { service } from '@ember/service';
let IliosConfigService = (_class = class IliosConfigService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "fetch", _descriptor, this);
    _initializerDefineProperty(this, "serverVariables", _descriptor2, this);
    _defineProperty(this, "_configPromise", null);
  }
  async getConfig() {
    if (!this._configPromise) {
      this._configPromise = this.fetch.getJsonFromApiHost('/application/config');
    }
    const config = await this._configPromise;
    return config;
  }
  async itemFromConfig(key) {
    const config = await this.getConfig();
    const obj = config.config;
    return key in obj ? obj[key] : null;
  }
  async getUserSearchType() {
    return this.itemFromConfig('userSearchType');
  }
  async getAuthenticationType() {
    return this.itemFromConfig('type');
  }
  async getMaxUploadSize() {
    return this.itemFromConfig('maxUploadSize');
  }
  async getApiVersion() {
    return this.itemFromConfig('apiVersion');
  }
  async getAppVersion() {
    const version = await this.itemFromConfig('appVersion');
    //ignore this development and bad build version string
    if (version === '0.1.0') {
      return '';
    } else {
      return version ?? '';
    }
  }
  async getTrackingEnabled() {
    return this.itemFromConfig('trackingEnabled');
  }
  async getTrackingCode() {
    return this.itemFromConfig('trackingCode');
  }
  async getLoginUrl() {
    return this.itemFromConfig('loginUrl');
  }
  async getCasLoginUrl() {
    return this.itemFromConfig('casLoginUrl');
  }
  get apiNameSpace() {
    const apiNameSpace = this.serverVariables.get('apiNameSpace');
    if (apiNameSpace) {
      //remove trailing slashes
      return apiNameSpace.replace(/\/+$/, '');
    }
    return '';
  }
  get apiHost() {
    const apiHost = this.serverVariables.get('apiHost');
    if (apiHost) {
      //remove trailing slashes
      return apiHost.replace(/\/+$/, '');
    }
    return '';
  }
  get errorCaptureEnabled() {
    const errorCaptureEnabled = this.serverVariables.get('errorCaptureEnabled');
    if (typeof errorCaptureEnabled === 'boolean') {
      return errorCaptureEnabled;
    }
    return errorCaptureEnabled === 'true';
  }
  async getSearchEnabled() {
    const searchEnabled = await this.itemFromConfig('searchEnabled');
    if (searchEnabled === null) {
      return false;
    }
    if (typeof searchEnabled === 'boolean') {
      return searchEnabled;
    }
    return searchEnabled === 'true';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetch", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "serverVariables", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { IliosConfigService as default };